<p-breadcrumb
  [model]="[
    { label: 'Produtos', routerLink: ['/products'] },
    {
      label: 'Ver Detalhes'
    }
  ]"
  [home]="{ label: '', routerLink: ['/'] }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex flex-wrap justify-between items-center">
    <div>
      <h5 class="font-bold">Detalhes do Produto</h5>
      <p>Confira e atualize informações</p>
    </div>
    <div class="flex gap-2">
      <p-button
        label="Voltar"
        [routerLink]="'/products'"
        severity="secondary"
        class="btn-secondary-outline"
        rounded
      >
      </p-button>
      @if(product()){
      <p-button
        label="Editar"
        [routerLink]="'/products/update/' + product()!.id"
        rounded
      >
      </p-button>
      }
    </div>
  </div>
</p-toolbar>

@if(product()){
<div class="flex flex-wrap xl:flex-nowrap gap-5">
  <div class="w-full xl:w-1/2">
    <div class="card mb-5!">
      <div class="space-y-5">
        <div class="block w-fit">
          <app-tag-status
            [status]="product()!.status"
            [text]="getStatusDescription(product()!.status)"
          />
        </div>
        <h5 class="font-bold">
          {{ product()!.name }}
        </h5>
        <p class="font-bold">
          SKU: <span class="font-normal"> {{ product()!.sku }}</span>
        </p>
        <p class="font-bold">
          Marca: <span class="font-normal"> {{ product()!.brandName }}</span>
        </p>
        <p class="font-bold">
          Categoria:
          <span class="font-normal">{{ product()!.categoryName }}</span>
        </p>
        <p class="font-bold">
          Modeo: <span class="font-normal">{{ product()!.modelName }}</span>
        </p>
        <p class="font-bold mb-0!">
          Versão:
          <span class="font-normal">{{ product()!.modelVersionName }}</span>
        </p>
      </div>
    </div>

    <div class="card">
      <h5 class="font-bold">Especificações Técnicas</h5>
      <div class="w-full wrap-break-word mt-5">
        <div
          class="prose"
          [innerHTML]="product()!.description | safeHtml"
        ></div>
      </div>
    </div>
  </div>
  <div class="w-full xl:w-1/2">
    <div class="card mb-5!">
      <h5 class="font-bold">Atributos</h5>
      @if(product()?.attributes && product()?.attributes!.length > 0){
      <div class="mt-5 space-y-5">
        @for(attr of product()!.attributes; track attr.variationAttributeId;){
        <p class="font-bold">
          {{ attr!.variationAttributeName }} -
          <span class="font-normal">{{ attr!.variationAttributeValue }}</span>
        </p>
        }
      </div>
      }@else{
      <p class="m-0!">Nenhum atributo cadastrado!</p>
      }
    </div>

    <div class="card">
      <h5 class="font-bold">Images</h5>
      @if(product()?.images && product()?.images!.length > 0){
      <div class="flex flex-wrap mt-10 gap-2">
        @for(img of product()!.images; track img.id){
        <img [src]="img.imageUrl" class="h-60 p-2 rounded-md" />
        }
      </div>
      }
    </div>
  </div>
</div>
}@else{
<div class="card">
  <div class="text-center">
    <h5>Produto não encontrado!</h5>
  </div>
</div>
} @if(loading()) {
<div
  class="absolute inset-0 z-1000 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
>
  <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
</div>
}
